import * as HttpService from './HttpService'

let namespace = 'timelogging-types'

const list = (params, cb, errorCb) => {
    HttpService.get(namespace + '/list', params, cb, errorCb)
}

const update = (id, params, cb, errorCb) => {
    HttpService.get(namespace + '/' + id + '/update', params, cb, errorCb)
}

export {
    list,
    update
}



// WEBPACK FOOTER //
// ./src/services/timeloggingTypesService.js